import {
  MonthRangeSelector,
  SmsBillingTable,
  useSmsMonthlyBilling,
} from "@/features/smsBilling";

export default function SmsBillingPage() {
  const { data, isLoading, isFetching, error } = useSmsMonthlyBilling();

  return (
    <div className="flex h-full flex-col bg-slate-50/50 p-4">
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-xl font-bold text-gray-900">SMS 월별 청구</h1>
          <p className="mt-0.5 text-xs text-gray-600">
            배차 업체별로 월간 문자 발송 건수와 비용을 집계합니다. 발송 기록(ul_sms_records) 원본을 직접 집계하므로 조회에 시간이 걸릴 수 있습니다
          </p>
        </div>
        <MonthRangeSelector disabled={isFetching} />
      </div>

      <SmsBillingTable
        data={data}
        isLoading={isLoading}
        isFetching={isFetching}
        error={error}
      />
    </div>
  );
}
